import React from 'react';
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import SimpleReactValidator from "simple-react-validator";
import { getUserRole } from "../utils/index";
import apiUrl from "../apiUrlConstant";
import axios from "axios";
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class CommentAdd extends React.Component {

    constructor(props) {
        super(props);

        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
        });

        this.state = {
            users: [],
            role: getUserRole(),
            initialValues: {

            }
        };
    }
    componentDidMount() {
    }

    render() {
        return (
            <div>
                {/* <h3>Add Comment</h3>
                <p>{this.props.leadId}</p> */}
                <Formik
                    enableReinitialize={true}
                    initialValues={this.state.initialValues}
                    onSubmit={(values, actions) => {

                        if (!this.validator.allValid()) {
                            this.validator.getErrorMessages();
                            this.validator.showMessages();
                            //this.forceUpdate();
                            return false;
                        }

                        values.lead_id = this.props.leadId;

                        var self = this;
                        axios({
                            method: "post",
                            url: apiUrl.apiUrl.url + "/leads/add-comment",
                            data: values,
                        }).then(function (response) {
                            if (response.data.status == 'success') {
                                setTimeout(() => {
                                    self.props.closeModal(); // Close modal after form submission
                                }, 1000);
                            } else {
                                actions.setSubmitting(false);
                                actions.setErrors(response.data);
                            }
                        });

                        // setTimeout(() => {
                        //     alert(JSON.stringify(values, null, 2));
                        //     setSubmitting(false);
                        //     }, 400
                        // );

                    }
                    }
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting
                    }) => (
                        <>


                            <div className="unitFormContainerNew">
                                <Form 
                                autoComplete="off"
                                onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault(); // Prevent form submission on Enter key press
                                        }
                                    }} onSubmit={handleSubmit}>
                                    <div className="newGridSectionParent">
                                        <div className="newGridSectionForFormMain newGridSectionForFormMainOneFr">

                                            <div className="newGridSectionInner">
                                                <label>Comment <span className="astrik">*</span></label>
                                                <div className="position-relative">
                                                    <Field as="textarea" name="comment" onChange={handleChange} />
                                                    {this.validator.message("Comment", values.comment, "required", { className: "text-danger" })}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                                            <button type="button" className='cancel_button' onClick={this.props.closeModal}>
                                                Cancel
                                            </button>
                                            <button type="submit" className='add_button' disabled={isSubmitting}>
                                                {isSubmitting && <FontAwesomeIcon icon={faSpinner} className="spinner-icon" />} Submit
                                            </button>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </>
                    )}

                </Formik>
            </div>
        );
    }
};

export default CommentAdd;